import React from 'react'
import { useHistory } from 'react-router'

import { HomeownerDetail } from '@new/__global/components/OmniSearch/components/ResultTemplates/UserDetail/HomeownerDetail'
import {
  OmniSearchHomeowner,
  SharedResultsProps,
  WithNavigationProps,
} from '@new/__global/components/OmniSearch/OmniSearch.types'

import { mountRouteUrl, ROUTES } from '@routes'

import ResultsTemplate from './ResultsTemplate'

interface HomeownersResultsProps extends WithNavigationProps, SharedResultsProps {
  homeowners: OmniSearchHomeowner[]
}

export const HomeownersResults = ({
  enabledNavigation,
  homeowners,
  setIndex,
  totalCount,
  searchTerm,
}: HomeownersResultsProps) => {
  const history = useHistory()

  const onClick = ({ id, fullName }: OmniSearchHomeowner) => {
    history.push(mountRouteUrl(ROUTES.homeowners.path, {}, { filter: fullName, homeowner: id }))
  }

  return (
    <ResultsTemplate
      activeIndex={0}
      data={homeowners}
      enabledNavigation={enabledNavigation}
      baseUrl={ROUTES.homeowners.path}
      queryParamKey="filter"
      searchTerm={searchTerm}
      totalCount={totalCount}
      onClick={onClick}
      setIndex={setIndex}
      titlePrefix={homeowners.length === 1 ? 'homeowner' : 'homeowners'}
      renderChildren={(homeowner: OmniSearchHomeowner) => <HomeownerDetail homeowner={homeowner} />}
    />
  )
}
